export default "__VITE_ASSET__d22820a2__"